
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-approved",
      function () {
        return require("private-next-pages/get-approved.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-approved"])
      });
    }
  